import { useEffect, useRef, useState } from "react";
import Loader from "../../../../components/Loader";
import { useLocation, useNavigate } from "react-router-dom";
import { Print } from "@mui/icons-material";
import { useReactToPrint } from "react-to-print";
import { Grid2 } from "@mui/material";
import { getSubjectVisitEntryDetailsService } from "../../../../services/subjectService";
import {
  formatDate,
  formatDynamicObject,
  safelyParse,
} from "../../../../utilities/helper";

const fields = [
  {
    label: "User Name",
    key: "userName",
  },
  {
    label: "Investigator Name",
    key: "investigatorName",
  },
  {
    label: "Site Number",
    key: "siteNumber",
  },
  {
    label: "Date/Time of Transaction",
    key: "dateTimeOfTransaction",
  },
  {
    label: "space",
    key: "",
  },
  {
    label: "Subject Number",
    key: "subjectNumber",
  },
  {
    label: "Visit Name",
    key: "visitName",
  },
  // {
  //   label: "Visit Date",
  //   key: "visitDate",
  // },
  {
    label: "space",
    key: "",
  },
];

const SubjectVisitEntry = () => {
  const [load, setLoad] = useState(false);
  const [subjectDetails, setSubjectDetails] = useState({
    subjectName: "",
    visitName: "",
    userName: "",
    investigatorName: "",
    siteNumber: "",
    dateTimeOfTransaction: "",
    subjectNumber: "",
    visitDate: "",
    patientId: "",
    attributes: [],
  });

  const printRef = useRef(null);
  const navigate = useNavigate();
  const id = useLocation()?.state?.id;

  const access_token = localStorage.getItem("access_token");
  const currentUserCultureCode = localStorage?.getItem(
    "currentUserCultureCode"
  );

  const { subjectName, visitName, patientId, attributes } = subjectDetails;

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    contentRef: printRef,
    pageStyle: `
    @page { 
      margin: 10mm !important; 
    }
    @media print {
      body {
        padding: 10px !important;
      }
      .print-area {
        padding: 10px !important;
      }
    }
  `,
  });

  useEffect(() => {
    if (id) {
      getSubjectDetails(id);
    }
  }, [id]);

  const getSubjectDetails = async (id) => {
    try {
      setLoad(true);
      const res = await getSubjectVisitEntryDetailsService(
        access_token,
        id,
        currentUserCultureCode
      );
      if (res?.data?.status === "200") {
        const data = res?.data?.result;
        setSubjectDetails((prev) => ({
          ...prev,
          userName: data?.userName,
          investigatorName: data?.site?.investigator,
          siteNumber: data?.site?.siteNumber,
          dateTimeOfTransaction: formatDate(data.completedTime),
          subjectNumber: data?.patientNumber,
          visitName: data?.visitName,
          visitDate: data?.visitDate || "",
          attributes: data?.answers || [],
          subjectName: data?.patientNumber,
          patientId: data?.patientId,
        }));
      }
    } catch (err) {
      console.log("Error", err?.message);
      if (err?.status === 401) {
        navigate("/unAuthorized");
      }
    } finally {
      setLoad(false);
    }
  };

  return (
    <>
      {load ? (
        <Loader />
      ) : (
        <div className="content-body">
          <p className="bread-crumbs-link-container">
            <button className="bread-crumbs-btn" onClick={(e) => navigate("/")}>
              Home
            </button>{" "}
            |{" "}
            <button
              className="bread-crumbs-btn"
              onClick={(e) => navigate("/subject")}
            >
              Subject Management
            </button>{" "}
            |{" "}
            <button
              className="bread-crumbs-btn"
              onClick={() => {
                navigate("/update-subject", {
                  state: {
                    id: patientId,
                  },
                });
              }}
            >
              {subjectName}
            </button>
            |{" "}
            <button className="bread-crumbs-btn" to="/update-subject">
              {visitName}
            </button>
            -{" "}
            <b style={{ color: "gray" }}>
              {localStorage?.getItem("studyName")}
            </b>
          </p>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "start",
              marginTop: "30px",
            }}
          >
            <div ref={printRef}>
              {fields.map((item, index) => (
                <div key={index}>
                  {item?.label === "space" ? (
                    <div
                      style={{
                        margin: "25px 0px",
                        height: "1px",
                      }}
                    ></div>
                  ) : (
                    <>
                      <div
                        style={{
                          marginBottom: "15px",
                        }}
                      >
                        <b
                          style={{
                            marginRight: "10px",
                            color: "grey",
                          }}
                        >
                          {item.label} :
                        </b>{" "}
                        <span>{subjectDetails[item.key]}</span>
                      </div>
                    </>
                  )}
                </div>
              ))}

              {/* Attributes mapping */}
              {attributes &&
                attributes?.length > 0 &&
                attributes
                  ?.filter((ele) => ele?.displayAnswer !== "")
                  ?.map((attr) => (
                    <div
                      key={attr?.id}
                      style={{
                        marginBottom: "15px",
                      }}
                    >
                      <b
                        style={{
                          marginRight: "10px",
                          color: "grey",
                        }}
                      >
                        {attr?.displayQuestion} :
                      </b>{" "}
                      <span>
                        {formatDynamicObject(safelyParse(attr?.displayAnswer))}
                      </span>
                    </div>
                  ))}
            </div>
            <div>
              <Print
                sx={{
                  fontSize: 40,
                  cursor: "pointer",
                  color: "#337ab7",
                }}
                onClick={() => {
                  handlePrint();
                }}
              />
            </div>
          </div>
          <Grid2
            alignItems={"end"}
            justifyContent="end"
            container
            sx={{ marginTop: "2%" }}
          >
            <Grid2 item md={6}>
              <button
                className="create-btn"
                onClick={() => {
                  navigate("/update-subject", {
                    state: {
                      id: patientId,
                    },
                  });
                }}
              >
                Back
              </button>
            </Grid2>
          </Grid2>
        </div>
      )}
    </>
  );
};

export default SubjectVisitEntry;
